import { Ref } from 'vue'

export const manageWorkersKey = Symbol(
  'Indicates if the components are in a context we manageWorkers mode is turned on',
)
export interface ManageWorkersInterface {
  manageWorkers: Ref<Boolean>
}
